
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import "./Auth.css";
// import logoImg from "../../assets/logo_on_white.png";
// import defaultLogo from "../../assets/logowhite-p.png";

// const Auth = () => {
//   const [identity, setIdentity] = useState("");
//   const [password, setPassword] = useState("");
//   const [companyLogo, setCompanyLogo] = useState(null);
//   const [companyName, setCompanyName] = useState("GENESIS TECH ENGINEERS");
//   const [showPasswordStep, setShowPasswordStep] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     document.body.classList.remove("light-mode");
//     document.documentElement.classList.remove("light-mode");

//     return () => {
//       document.body.classList.add("light-mode");
//       document.documentElement.classList.add("light-mode");
//     };
//   }, []);

//   useEffect(() => {
//     const emailParts = identity.split("@");
//     if (emailParts.length !== 2) {
//       setCompanyLogo(null);
//       setCompanyName("GENESIS TECH ENGINEERS");
//       return;
//     }

//     const domain = emailParts[1];
//     fetch("/gt-api/get_company_logo.php", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json"
//       },
//       body: JSON.stringify({ domain })
//     })
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) {
//           setCompanyName(data.org_name);
//           if (data.company_logo) {
//             setCompanyLogo(`/gt-api/${data.company_logo}`);
//           } else {
//             setCompanyLogo(null);
//           }
//         } else {
//           setCompanyLogo(null);
//           setCompanyName("GENESIS TECH ENGINEERS");
//         }
//       })
//       .catch(() => {
//         setCompanyLogo(null);
//         setCompanyName("GENESIS TECH ENGINEERS");
//       });
//   }, [identity]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch("/gt-api/auth.php", {
//         method: "POST",
//         credentials: "include",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({ identity, password })
//       });

//       const data = await response.json();
//       console.log("LOGIN RESPONSE:", data);

//       if (data.success) {
//         localStorage.setItem("userData", JSON.stringify(data));

//         if (data.role === "Management" && data.setupCompleted === 0) {
//           navigate(`/dashboard/${data.role}/CompanySetup`, {
//             state: {
//               empId: data.id,
//               userName: data.full_name
//             }
//           });
//         } else {
//           navigate(`/dashboard/${data.role}`, {
//             state: {
//               empId: data.id,
//               userName: data.full_name
//             }
//           });
//         }
//       } else {
//         alert(data.message);
//       }
//     } catch (error) {
//       alert("System Error: Cannot reach auth.php. Check XAMPP.");
//     }
//   };

//   const handleContinue = (e) => {
//     e.preventDefault();
//     if (!identity.includes("@")) {
//       alert("Enter valid email");
//       return;
//     }
//     setShowPasswordStep(true);
//   };

//   return (
//     <div className="split-auth-page light-mode-page">
//       <div className="login-page-background-overlay"></div>

//       <div className="login-container-card">
//         {/* LEFT COLUMN - HCM PORTAL BRANDING */}
//         <div className="login-card-left">
//           <div className="hcm-left-header">
//             <div className="company-info">
//               {/* <span className="company-logo-text">GTELINQ</span> */}
//               {/* <span className="portal-badge">HCM PORTAL</span> */}
//             </div>
//           </div>

//           <div className="hcm-left-body">
//             <h1 className="brand-quote">
//               Human <br />
//               <span className="nowrap-line">
//                 <span className="text-highlight underline-text">Capital</span> Management.
//               </span>
//             </h1>

//             <h2 className="brand-subline">
//               Streamlining <span className="text-highlight">Enterprise</span> Workflows.
//             </h2>
//           </div>

//           <div className="hcm-left-footer">
//             <span className="secure-badge">
//               <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lock-svg">
//                 <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                 <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//               </svg>
//               Secure HCM Platform Connection
//             </span>
//           </div>
//         </div>

//         {/* RIGHT COLUMN - DYNAMIC LOGIN FORM */}
//         <div className="login-card-right">
//           <div className="form-wrapper">
//             <div className="auth-portal-header">
//               <div className="logo-hex-frame">
//                 <img
//                   src={showPasswordStep ? (companyLogo || logoImg) : defaultLogo}
//                   alt="Company Logo"
//                   className="auth-center-logo"
//                 />
//               </div>
//               <h3 className="portal-title">{showPasswordStep ? companyName : ""}</h3>
//               {/* <p className="portal-subtitle">Employee Onboarding Portal</p> */}
//             </div>

//             <form className="main-form" onSubmit={showPasswordStep ? handleSubmit : handleContinue}>
//               {!showPasswordStep ? (
//                 <>
//                   <div className="input-group">
//                     <label className="onboarding-label">Corporate / Personal Email</label>
//                     <div className="input-with-icon">
//                       <span className="input-icon">
//                         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
//                           <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
//                           <circle cx="12" cy="7" r="4"></circle>
//                         </svg>
//                       </span>
//                       <input
//                         type="email"
//                         className="onboarding-input"
//                         placeholder="name@example.com"
//                         value={identity}
//                         onChange={(e) => setIdentity(e.target.value)}
//                         required
//                       />
//                     </div>
//                   </div>

//                   <button type="submit" className="primary-submit onboarding-btn">
//                     <span>Continue</span>
//                   </button>
//                 </>
//               ) : (
//                 <>
//                   <div className="input-group readonly-group">
//                     <label className="onboarding-label">Corporate / Personal Email</label>
//                     <div className="input-with-icon">
//                       <span className="input-icon">
//                         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
//                           <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
//                           <circle cx="12" cy="7" r="4"></circle>
//                         </svg>
//                       </span>
//                       <input
//                         type="email"
//                         className="onboarding-input"
//                         value={identity}
//                         readOnly
//                       />
//                     </div>
//                   </div>

//                   <div className="input-group">
//                     <label className="onboarding-label">Password</label>
//                     <div className="input-with-icon">
//                       <span className="input-icon">
//                         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
//                           <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                           <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//                         </svg>
//                       </span>
//                       <input
//                         type={showPassword ? "text" : "password"}
//                         className="onboarding-input password-input"
//                         placeholder="••••••••••••"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         required
//                       />
//                       <button
//                         type="button"
//                         className="password-toggle-btn"
//                         onClick={() => setShowPassword(!showPassword)}
//                       >
//                         {showPassword ? (
//                           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="eye-svg">
//                             <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
//                             <line x1="1" y1="1" x2="23" y2="23"></line>
//                           </svg>
//                         ) : (
//                           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="eye-svg">
//                             <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
//                             <circle cx="12" cy="12" r="3"></circle>
//                           </svg>
//                         )}
//                       </button>
//                     </div>
//                   </div>

//                   <div className="form-options-row">
//                     <label className="remember-me-label">
//                       <input type="checkbox" className="remember-me-checkbox" />
//                       <span>Remember me</span>
//                     </label>
//                     <span
//                       className="forgot-password-link"
//                       onClick={() =>
//                         navigate("/forgot-password", {
//                           state: { email: identity }
//                         })
//                       }
//                     >
//                       Forgot Password?
//                     </span>
//                   </div>

//                   <button type="submit" className="primary-submit onboarding-btn">
//                     <span>Sign In</span>
//                   </button>

//                   <div className="back-link-container">
//                     <span
//                       className="back-to-email-link"
//                       onClick={() => {
//                         setShowPasswordStep(false);
//                         setPassword("");
//                       }}
//                     >
//                       ← Back to email
//                     </span>
//                   </div>
//                 </>
//               )}
//             </form>

//             <div className="portal-form-footer">
//               <p className="footer-warning">Protected System Access Node.</p>
//               <p className="footer-warning">Unauthorized login attempts are audited and logged.</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Auth;

























//  working before document 

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import "./Auth.css";
// import logoImg from "../../assets/logo_on_white.png";
// import defaultLogo from "../../assets/logowhite-p.png";

// const Auth = () => {
//   const [rememberMe, setRememberMe] = useState(() => {
//     return localStorage.getItem("rememberMe") === "true";
//   });
//   const [identity, setIdentity] = useState(() => {
//     const savedRemember = localStorage.getItem("rememberMe") === "true";
//     return savedRemember ? (localStorage.getItem("rememberedEmail") || "") : "";
//   });
//   const [password, setPassword] = useState(() => {
//     const savedRemember = localStorage.getItem("rememberMe") === "true";
//     return savedRemember ? (localStorage.getItem("rememberedPassword") || "") : "";
//   });
//   const [companyLogo, setCompanyLogo] = useState(null);
//   const [companyName, setCompanyName] = useState("GENESIS TECH ENGINEERS");
//   const [showPasswordStep, setShowPasswordStep] = useState(() => {
//     const savedRemember = localStorage.getItem("rememberMe") === "true";
//     const savedEmail = localStorage.getItem("rememberedEmail");
//     const savedPassword = localStorage.getItem("rememberedPassword");
//     return Boolean(savedRemember && savedEmail && savedPassword);
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     document.body.classList.remove("light-mode");
//     document.documentElement.classList.remove("light-mode");
//   }, []);

//   useEffect(() => {
//     const emailParts = identity.split("@");
//     if (emailParts.length !== 2) {
//       setCompanyLogo(null);
//       setCompanyName("GENESIS TECH ENGINEERS");
//       return;
//     }

//     const domain = emailParts[1];
//     fetch("/gt-api/get_company_logo.php", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json"
//       },
//       body: JSON.stringify({ domain })
//     })
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) {
//           setCompanyName(data.org_name);
//           if (data.company_logo) {
//             setCompanyLogo(`/gt-api/${data.company_logo}`);
//           } else {
//             setCompanyLogo(null);
//           }
//         } else {
//           setCompanyLogo(null);
//           setCompanyName("GENESIS TECH ENGINEERS");
//         }
//       })
//       .catch(() => {
//         setCompanyLogo(null);
//         setCompanyName("GENESIS TECH ENGINEERS");
//       });
//   }, [identity]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch("/gt-api/auth.php", {
//         method: "POST",
//         credentials: "include",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({ identity, password })
//       });

//       const data = await response.json();
//       console.log("LOGIN RESPONSE:", data);

//       if (data.success) {
//         if (rememberMe) {
//           localStorage.setItem("rememberMe", "true");
//           localStorage.setItem("rememberedEmail", identity);
//           localStorage.setItem("rememberedPassword", password);
//         } else {
//           localStorage.removeItem("rememberMe");
//           localStorage.removeItem("rememberedEmail");
//           localStorage.removeItem("rememberedPassword");
//         }

//         localStorage.setItem("userData", JSON.stringify(data));

//         if (data.role === "Management" && data.setupCompleted === 0) {
//           navigate(`/dashboard/${data.role}/CompanySetup`, {
//             state: {
//               empId: data.id,
//               userName: data.full_name
//             }
//           });
//         } else {
//           navigate(`/dashboard/${data.role}`, {
//             state: {
//               empId: data.id,
//               userName: data.full_name
//             }
//           });
//         }
//       } else {
//         alert(data.message);
//       }
//     } catch (error) {
//       alert("System Error: Cannot reach auth.php. Check XAMPP.");
//     }
//   };

//   const handleContinue = (e) => {
//     e.preventDefault();
//     if (!identity.includes("@")) {
//       alert("Enter valid email");
//       return;
//     }
//     const savedRemember = localStorage.getItem("rememberMe") === "true";
//     const savedEmail = localStorage.getItem("rememberedEmail");
//     const savedPassword = localStorage.getItem("rememberedPassword");
//     if (savedRemember && savedEmail && savedEmail.toLowerCase() === identity.toLowerCase() && savedPassword) {
//       setPassword(savedPassword);
//       setRememberMe(true);
//     }
//     setShowPasswordStep(true);
//   };

//   return (
//     <div className="split-auth-page light-mode-page">
//       <div className="login-page-background-overlay"></div>

//       <div className="login-container-card">
//         {/* LEFT COLUMN - HCM PORTAL BRANDING */}
//         <div className="login-card-left">
//           <div className="hcm-left-header">
//             <div className="company-info">
//               {/* <span className="company-logo-text">GTELINQ</span> */}
//               {/* <span className="portal-badge">HCM PORTAL</span> */}
//             </div>
//           </div>

//           <div className="hcm-left-body">
//             <h1 className="brand-quote">
//               Human <br />
//               <span className="nowrap-line">
//                 <span className="text-highlight underline-text">Capital</span> Management.
//               </span>
//             </h1>

//             <h2 className="brand-subline">
//               Streamlining <span className="text-highlight">Enterprise</span> Workflows.
//             </h2>
//           </div>

//           <div className="hcm-left-footer">
//             <span className="secure-badge">
//               <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lock-svg">
//                 <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                 <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//               </svg>
//               Secure HCM Platform Connection
//             </span>
//           </div>
//         </div>

//         {/* RIGHT COLUMN - DYNAMIC LOGIN FORM */}
//         <div className="login-card-right">
//           <div className="form-wrapper">
//             <div className="auth-portal-header">
//               <div className="logo-hex-frame">
//                 <img
//                   src={showPasswordStep ? (companyLogo || logoImg) : defaultLogo}
//                   alt="Company Logo"
//                   className="auth-center-logo"
//                 />
//               </div>
//               <h3 className="portal-title">{showPasswordStep ? companyName : ""}</h3>
//               {/* <p className="portal-subtitle">Employee Onboarding Portal</p> */}
//             </div>

//             <form className="main-form" onSubmit={showPasswordStep ? handleSubmit : handleContinue}>
//               {!showPasswordStep ? (
//                 <>
//                   <div className="input-group">
//                     <label className="onboarding-label">Corporate / Personal Email</label>
//                     <div className="input-with-icon">
//                       <span className="input-icon">
//                         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
//                           <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
//                           <circle cx="12" cy="7" r="4"></circle>
//                         </svg>
//                       </span>
//                       <input
//                         type="email"
//                         className="onboarding-input"
//                         placeholder="name@example.com"
//                         value={identity}
//                         onChange={(e) => setIdentity(e.target.value)}
//                         required
//                       />
//                     </div>
//                   </div>

//                   <button type="submit" className="primary-submit onboarding-btn">
//                     <span>Continue</span>
//                   </button>
//                 </>
//               ) : (
//                 <>
//                   <div className="input-group readonly-group">
//                     <label className="onboarding-label">Corporate / Personal Email</label>
//                     <div className="input-with-icon">
//                       <span className="input-icon">
//                         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
//                           <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
//                           <circle cx="12" cy="7" r="4"></circle>
//                         </svg>
//                       </span>
//                       <input
//                         type="email"
//                         className="onboarding-input"
//                         value={identity}
//                         readOnly
//                       />
//                     </div>
//                   </div>

//                   <div className="input-group">
//                     <label className="onboarding-label">Password</label>
//                     <div className="input-with-icon">
//                       <span className="input-icon">
//                         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
//                           <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                           <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//                         </svg>
//                       </span>
//                       <input
//                         type={showPassword ? "text" : "password"}
//                         className="onboarding-input password-input"
//                         placeholder="••••••••••••"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         required
//                       />
//                       <button
//                         type="button"
//                         className="password-toggle-btn"
//                         onClick={() => setShowPassword(!showPassword)}
//                       >
//                         {showPassword ? (
//                           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="eye-svg">
//                             <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
//                             <line x1="1" y1="1" x2="23" y2="23"></line>
//                           </svg>
//                         ) : (
//                           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="eye-svg">
//                             <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
//                             <circle cx="12" cy="12" r="3"></circle>
//                           </svg>
//                         )}
//                       </button>
//                     </div>
//                   </div>

//                   <div className="form-options-row">
//                     <label className="remember-me-label">
//                       <input
//                         type="checkbox"
//                         className="remember-me-checkbox"
//                         checked={rememberMe}
//                         onChange={(e) => setRememberMe(e.target.checked)}
//                       />
//                       <span>Remember me</span>
//                     </label>
//                     <span
//                       className="forgot-password-link"
//                       onClick={() =>
//                         navigate("/forgot-password", {
//                           state: { email: identity }
//                         })
//                       }
//                     >
//                       Forgot Password?
//                     </span>
//                   </div>

//                   <button type="submit" className="primary-submit onboarding-btn">
//                     <span>Sign In</span>
//                   </button>

//                   <div className="back-link-container">
//                     <span
//                       className="back-to-email-link"
//                       onClick={() => {
//                         setShowPasswordStep(false);
//                         setPassword("");
//                       }}
//                     >
//                       ← Back to email
//                     </span>
//                   </div>
//                 </>
//               )}
//             </form>

//             <div className="portal-form-footer">
//               <p className="footer-warning">Protected System Access Node.</p>
//               <p className="footer-warning">Unauthorized login attempts are audited and logged.</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Auth;
































import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.css";
import logoImg from "../../assets/logo_on_white.png";
import defaultLogo from "../../assets/logowhite-p.png";

const Auth = () => {
  const [rememberMe, setRememberMe] = useState(() => {
    return localStorage.getItem("rememberMe") === "true";
  });
  const [identity, setIdentity] = useState(() => {
    const savedRemember = localStorage.getItem("rememberMe") === "true";
    return savedRemember ? (localStorage.getItem("rememberedEmail") || "") : "";
  });
  const [password, setPassword] = useState(() => {
    const savedRemember = localStorage.getItem("rememberMe") === "true";
    return savedRemember ? (localStorage.getItem("rememberedPassword") || "") : "";
  });
  const [companyLogo, setCompanyLogo] = useState(null);
  const [companyName, setCompanyName] = useState("GENESIS TECH ENGINEERS");
  const [showPasswordStep, setShowPasswordStep] = useState(() => {
    const savedRemember = localStorage.getItem("rememberMe") === "true";
    const savedEmail = localStorage.getItem("rememberedEmail");
    const savedPassword = localStorage.getItem("rememberedPassword");
    return Boolean(savedRemember && savedEmail && savedPassword);
  });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.remove("light-mode");
    document.documentElement.classList.remove("light-mode");
  }, []);

  useEffect(() => {
    const emailParts = identity.split("@");
    if (emailParts.length !== 2) {
      setCompanyLogo(null);
      setCompanyName("GENESIS TECH ENGINEERS");
      return;
    }

    const domain = emailParts[1];
    fetch("/gt-api/get_company_logo.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ domain })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setCompanyName(data.org_name);
          if (data.company_logo) {
            setCompanyLogo(`/gt-api/${data.company_logo}`);
          } else {
            setCompanyLogo(null);
          }
        } else {
          setCompanyLogo(null);
          setCompanyName("GENESIS TECH ENGINEERS");
        }
      })
      .catch(() => {
        setCompanyLogo(null);
        setCompanyName("GENESIS TECH ENGINEERS");
      });
  }, [identity]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("/gt-api/auth.php", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ identity, password })
      });

      const data = await response.json();
      console.log("LOGIN RESPONSE:", data);

      if (data.success) {
        if (rememberMe) {
          localStorage.setItem("rememberMe", "true");
          localStorage.setItem("rememberedEmail", identity);
          localStorage.setItem("rememberedPassword", password);
        } else {
          localStorage.removeItem("rememberMe");
          localStorage.removeItem("rememberedEmail");
          localStorage.removeItem("rememberedPassword");
        }

        localStorage.setItem("userData", JSON.stringify(data));

        // 🚫 CHECK DOCUMENT COMPLIANCE ACCESS RESTRICTION (Management & Manager are NEVER locked)
        const userRole = (data.role || "").toLowerCase();
        if (userRole !== "management" && userRole !== "manager") {
          try {
            const targetEmpId = data.EmpId || data.empId || data.id;
            const checkRes = await fetch(`/gt-api/check_employee_doc_restriction.php?emp_id=${encodeURIComponent(targetEmpId)}&role=${encodeURIComponent(data.role)}`);
            const checkData = await checkRes.json();
            if (checkData.restricted) {
              alert(checkData.message || "Due to overdue document submission, your dashboard access has been restricted. Please contact Management / HR to unlock your account.");
              return;
            }
          } catch (docErr) {
            console.error("Doc restriction check error:", docErr);
          }
        }

        if (data.role === "Management" && data.setupCompleted === 0) {
          navigate(`/dashboard/${data.role}/CompanySetup`, {
            state: {
              empId: data.id,
              userName: data.full_name
            }
          });
        } else {
          navigate(`/dashboard/${data.role}`, {
            state: {
              empId: data.id,
              userName: data.full_name
            }
          });
        }
      } else {
        alert(data.message);
      }
    } catch (error) {
      alert("System Error: Cannot reach auth.php. Check XAMPP.");
    }
  };

  const handleContinue = (e) => {
    e.preventDefault();
    if (!identity.includes("@")) {
      alert("Enter valid email");
      return;
    }
    const savedRemember = localStorage.getItem("rememberMe") === "true";
    const savedEmail = localStorage.getItem("rememberedEmail");
    const savedPassword = localStorage.getItem("rememberedPassword");
    if (savedRemember && savedEmail && savedEmail.toLowerCase() === identity.toLowerCase() && savedPassword) {
      setPassword(savedPassword);
      setRememberMe(true);
    }
    setShowPasswordStep(true);
  };

  return (
    <div className="split-auth-page light-mode-page">
      <div className="login-page-background-overlay"></div>

      <div className="login-container-card">
        {/* LEFT COLUMN - HCM PORTAL BRANDING */}
        <div className="login-card-left">
          <div className="hcm-left-header">
            <div className="company-info">
              {/* <span className="company-logo-text">GTELINQ</span> */}
              {/* <span className="portal-badge">HCM PORTAL</span> */}
            </div>
          </div>

          <div className="hcm-left-body">
            <h1 className="brand-quote">
              Human <br />
              <span className="nowrap-line">
                <span className="text-highlight underline-text">Capital</span> Management.
              </span>
            </h1>

            <h2 className="brand-subline">
              Streamlining <span className="text-highlight">Enterprise</span> Workflows.
            </h2>
          </div>

          <div className="hcm-left-footer">
            <span className="secure-badge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lock-svg">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              Secure HCM Platform Connection
            </span>
          </div>
        </div>

        {/* RIGHT COLUMN - DYNAMIC LOGIN FORM */}
        <div className="login-card-right">
          <div className="form-wrapper">
            <div className="auth-portal-header">
              <div className="logo-hex-frame">
                <img
                  src={showPasswordStep ? (companyLogo || logoImg) : defaultLogo}
                  alt="Company Logo"
                  className="auth-center-logo"
                />
              </div>
              <h3 className="portal-title">{showPasswordStep ? companyName : ""}</h3>
              {/* <p className="portal-subtitle">Employee Onboarding Portal</p> */}
            </div>

            <form className="main-form" onSubmit={showPasswordStep ? handleSubmit : handleContinue}>
              {!showPasswordStep ? (
                <>
                  <div className="input-group">
                    <label className="onboarding-label">Corporate / Personal Email</label>
                    <div className="input-with-icon">
                      <span className="input-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                      </span>
                      <input
                        type="email"
                        className="onboarding-input"
                        placeholder="name@example.com"
                        value={identity}
                        onChange={(e) => setIdentity(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <button type="submit" className="primary-submit onboarding-btn">
                    <span>Continue</span>
                  </button>
                </>
              ) : (
                <>
                  <div className="input-group readonly-group">
                    <label className="onboarding-label">Corporate / Personal Email</label>
                    <div className="input-with-icon">
                      <span className="input-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                      </span>
                      <input
                        type="email"
                        className="onboarding-input"
                        value={identity}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="input-group">
                    <label className="onboarding-label">Password</label>
                    <div className="input-with-icon">
                      <span className="input-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
                          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                        </svg>
                      </span>
                      <input
                        type={showPassword ? "text" : "password"}
                        className="onboarding-input password-input"
                        placeholder="••••••••••••"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <button
                        type="button"
                        className="password-toggle-btn"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="eye-svg">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                            <line x1="1" y1="1" x2="23" y2="23"></line>
                          </svg>
                        ) : (
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="eye-svg">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="form-options-row">
                    <label className="remember-me-label">
                      <input
                        type="checkbox"
                        className="remember-me-checkbox"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                      <span>Remember me</span>
                    </label>
                    <span
                      className="forgot-password-link"
                      onClick={() =>
                        navigate("/forgot-password", {
                          state: { email: identity }
                        })
                      }
                    >
                      Forgot Password?
                    </span>
                  </div>

                  <button type="submit" className="primary-submit onboarding-btn">
                    <span>Sign In</span>
                  </button>

                  <div className="back-link-container">
                    <span
                      className="back-to-email-link"
                      onClick={() => {
                        setShowPasswordStep(false);
                        setPassword("");
                      }}
                    >
                      ← Back to email
                    </span>
                  </div>
                </>
              )}
            </form>

            <div className="portal-form-footer">
              <p className="footer-warning">Protected System Access Node.</p>
              <p className="footer-warning">Unauthorized login attempts are audited and logged.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
